import StandardRestError from './Standard'

class MonthlyLimitExceededError extends StandardRestError {
  static CODE = 'MONTHLY_LIMIT_EXCEEDED'

  constructor(
    message = 'Monthly limit to process pages exceeded.',
    status = 429,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default MonthlyLimitExceededError
